/* eslint-disable no-console */
import React, { useState } from 'react';
import { useSnackbar } from 'react-simple-snackbar';
import { useNavigate } from 'react-router-dom';
import { convertToFhir } from '../../fhir-evolver';
import { addBundle } from '../../api/bundleRequest';
import Loader from '../../components/Loader';
import Station from '../../containers/NurseFunctions/Station';

const StationAdd = () => {
    const [spinner, setSpinner] = useState(false);
    const navigate = useNavigate();
    const options = {
        position: 'bottom-center',
        style: {
            background: 'linear-gradient(178.36deg, rgb(0, 162, 183) 1.4%, rgba(0, 0, 0, 0.9) 300.49%)',
            border: '#00A2B7',
            color: 'white',
            fontFamily: 'roboto',
            fontSize: '20px',
            textAlign: 'center'
        }
    };
    const [snackbarOpen] = useSnackbar(options);

    const onAdd = (obj) => {
        console.log('secondaryobj', obj);
        convertToFhir('SecondaryCare', obj).then((output) => {
            console.log('secondarytofhir', output);
            addBundle(output).then((httpResponse) => {
                console.log('addbundle', httpResponse);
                setSpinner(false);
                snackbarOpen('SecondaryCare Created Successfully');
                navigate(`/nurse/assessment/${obj.Encounter}`);
            });
        }).catch((e) => console.log(e));
    };
    return (
        <>
            <Loader showSpinner={spinner} />
            <Station handleSubmit={onAdd} isDisabled={false} isAdd={true} type='add'/>
        </>
    );
};

export default StationAdd;
